<template>
  <div class="d-none">
    <button class="btn btn-primary" @click="$bvModal.show('custom')">
      custom
    </button>

    <button class="btn btn-primary" @click="$bvModal.show('signIn')">
      login
    </button>

    <button class="btn btn-primary" @click="$bvModal.show('signUp')">
      signup
    </button>

    <button class="btn btn-primary" @click="$bvModal.show('otp')">otp</button>

    <button class="btn btn-primary" @click="$bvModal.show('forgotPassword')">
      forgotPassword
    </button>

    <button class="btn btn-primary" @click="$bvModal.show('verification')">
      verification
    </button>

    <button class="btn btn-primary" @click="$bvModal.show('SelectCity')">
      Select City
    </button>

    <button class="btn btn-primary" @click="$bvModal.show('SelectCinema')">
      Select City
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modals/allModalHeader.vue